export default {
    name: 'TabMixin',

    data() {
        return {
            active_tab: 'account',
        }
    },

    methods: {
        changeTab(item) {
            this.active_tab = item;
        },
    },

    // check url which screen we are showing
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.params.type) {
                vm.active_tab = to.params.type;
            }
        });
    },

    // check url which screen we are showing
    beforeRouteUpdate(to, from, next) {
        next(vm => {
            if (to.params.type) {
                vm.active_tab = to.params.type;
            }
        });
    },
}